import { api } from './api'
import type { RecentActivityResponse } from '../types'

export interface RecentActivityParams {
  time_window?: string
}

export class FileUploadsService {
  /**
   * Get recent upload activity stats
   */
  static async getRecentActivity(params: RecentActivityParams = {}): Promise<RecentActivityResponse> {
    try {
      const { time_window = '24h' } = params

      const response = await api.get<RecentActivityResponse>('/file-uploads/stats/recent-activity', {
        params: {
          time_window
        }
      })

      return response.data
    } catch (error: any) {
      console.error('Failed to fetch recent activity:', error)
      throw new Error(error.response?.data?.message || 'Failed to fetch recent activity')
    }
  }
}